// export const API_BASE_URL = "http://192.168.1.131:5000";
export const API_BASE_URL = "https://gigprodapi.leapfrogtechafrica.com";
//export const API_BASE_URL = "http://localhost:8000";
//export const API_BASE_URL = "http://138.197.190.215:5006";
